// src/features/service/serviceActions.js
import { createAction } from '@reduxjs/toolkit';
import { getServices, getServiceDetails } from '../../services/serviceService';

// Action Creators
export const clearMessages = createAction('service/clearMessages');

// Get Services
export const getServicesStart = createAction('service/getServicesStart');
export const getServicesSuccess = createAction('service/getServicesSuccess');
export const getServicesFailure = createAction('service/getServicesFailure');

// Get Service Details
export const getServiceDetailsStart = createAction('service/getServiceDetailsStart');
export const getServiceDetailsSuccess = createAction('service/getServiceDetailsSuccess');
export const getServiceDetailsFailure = createAction('service/getServiceDetailsFailure');

// Thunks
export const fetchServices = (serviceData) => async (dispatch) => {
    dispatch(getServicesStart());
    try {
        const response = await getServices(serviceData);
        if(response.data.status === false){
            dispatch(getServicesFailure(response.data));
        }else{
            dispatch(getServicesSuccess(response.data));
        }
    } catch (error) {
        dispatch(getServicesFailure(error.message));
    }
};

export const fetchServiceDetails = (slug) => async (dispatch) => {
    dispatch(getServiceDetailsStart());
    try {
        const response = await getServiceDetails(slug);
        if(response.data.status === false){
            dispatch(getServiceDetailsFailure(response.data));
        }else{
            dispatch(getServiceDetailsSuccess(response.data));
        }
    } catch (error) {
        dispatch(getServiceDetailsFailure(error.message));
    }
};
